import { forwardRef } from "react";
import cx from "classnames";
import { gql } from "utils/urql";
import { ArticleHeadingFragment } from "types/api";
import styles from "./ArticleHeading.module.scss";

const ArticleHeading = forwardRef<HTMLHeadingElement, ArticleHeadingFragment>(
  function ArticleHeading({ idAttr, headingSubtype, innerHtml }, ref) {
    const HeadingTag = `h${parseInt(headingSubtype.split("HED")[1]) + 1}` as
      | "h2"
      | "h3"
      | "h4"
      | "h5";

    return (
      <HeadingTag
        ref={ref}
        id={idAttr || undefined}
        className={cx(styles.root, styles[headingSubtype.toLowerCase()])}
        dangerouslySetInnerHTML={{ __html: innerHtml }}
      />
    );
  }
);

ArticleHeading.fragment = gql`
  fragment articleHeading on ArticleHeading {
    headingSubtype: subtype
    idAttr
    innerHtml
  }
`;

export default ArticleHeading;
